export function isProductionEnvironment(): boolean {
  /*
   * Determines if the application is using a production build
   */
  const { NODE_ENV = '' } = process.env;
  return !['development'].includes(NODE_ENV);
}

export function isTestEnvironment(): boolean {
  /*
   * Determines if the application is currently being tested by Cypress or jest
   * NOTE: We mimic entire production environments for QA Automation
   * */
  const { NODE_ENV = '' } = process.env;
  const isCypressTestingEnvironment =
    !!window.Cypress && ['development'].includes(NODE_ENV);
  return ['test'].includes(NODE_ENV) || isCypressTestingEnvironment;
}
